import React, { ReactNode } from 'react';

import styled from 'styled-components';

const Container = styled.div`
  border-radius: 10px;
  border: solid 1px var(--line-gray);
  padding: 30px;
  padding-bottom: 0;
  background-color: var(--white);
`;

const Header = styled.div`
  display: flex;
  flex-flow: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
`;

const TitleGroup = styled.div`
  display: flex;
  flex-flow: row;
  gap: 10px;
`;

const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: linear-gradient(to bottom, var(--lavender-frost), var(--lavender-frost-end));
  border-radius: 4px;
  height: 32px;
  width: 32px;
  flex-shrink: 0;
`;

const Title = styled.div`
  font-size: 20px;
  font-family: var(--font-bold);
`;

const Subtitle = styled.div`
  font-size: 14px;
  color: var(--text-secondary);
`;

const Action = styled.div`
  flex-shrink: 0;
`;

type Props = {
  title: string;
  subtitle: string;
  action?: ReactNode;
  testId: string;
  className?: string;
  children: ReactNode;
};

const DigestSectionCard = ({ title, subtitle, action, testId, className, children }: Props) => (
  <Container className={className} data-test-id={testId}>
    <Header>
      <TitleGroup>
        <ImageContainer>
          <img src="/icons/rule-blue.svg" width="20" height="20" alt="" />
        </ImageContainer>
        <div>
          <Title>{title}</Title>
          <Subtitle>{subtitle}</Subtitle>
        </div>
      </TitleGroup>
      {action && <Action>{action}</Action>}
    </Header>
    {children}
  </Container>
);

export default DigestSectionCard;
